import { get, isMockMode, simulateDelay } from "../api";

export const getVersionInfo = ({ productId }) => {
	if (isMockMode()) {
		const testData = {
			downloadUri: "https://files.ingenious.tk/test.exe",
			latestVersion: "v1.5",
			productId: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
		};

		return simulateDelay(50, () => testData);
	}

	return get(`Products/GetVersionInfo?ProductId=${productId}`);
};
